import { FormattedMessage } from 'react-intl';
import { PaloField, PaloFormGrid, PaloFormSection } from '@synergy/components-palo';
import { forwardRef } from 'react';

import {
    PaymentTermAutocomplete,
    PaymentTermAutocompleteRef,
} from '../../../../../../common/components/payment-term-autocomplete/payment-term-autocomplete';
import { overviewFieldNames } from '../../../models/overview-form-values';

interface PaloOverviewSectionPaymentTermsProps {
    readonly?: boolean;
}

export const PaloOverviewSectionPaymentTerms = forwardRef<
    PaymentTermAutocompleteRef,
    PaloOverviewSectionPaymentTermsProps
>((props, innerRef) => {
    const { readonly } = props;

    return (
        <PaloFormSection title={<FormattedMessage id="app.label.paymentTerm" />}>
            <PaloFormGrid>
                <PaloField
                    label={
                        <>
                            <FormattedMessage id="app.label.paymentTerm" /> *
                        </>
                    }
                    name={overviewFieldNames.paymentTerm}
                >
                    <PaymentTermAutocomplete
                        name={overviewFieldNames.paymentTerm}
                        ref={innerRef}
                        label={<></>}
                        disabled={readonly}
                        required={false}
                    />
                </PaloField>
            </PaloFormGrid>
        </PaloFormSection>
    );
});
